export default __webpack_public_path__ + "static/media/search.cadee8cd.png";